import { ViewRef, ChangeDetectorRef } from '@angular/core';

export function safeDetectChanges(cdr: ChangeDetectorRef): void {
    if (!(cdr as ViewRef).destroyed) {
        cdr.detectChanges();
    }
}
